import type { State } from 'state';

export const getShown = (state: State) => state.ui.search.shown;
export const getTerm = (state: State) => state.ui.search.term;
export const getQueryTime = (state: State) => state.ui.search.time;
export const getSearchResults = (state: State) => state.ui.search.results;
export const getIsSearching = (state: State) => state.ui.search.isSearching;
export const hasSearchResultError = (state: State) => state.ui.search.hasError;
export const getSearchStartTime = (state: State) => state.ui.search.searchStartTime;

// loading states for respective searches
export const getIsSearchingPortals = (state: State) => state.ui.search.isSearchingPortals;
export const getIsSearchingRequestTypes = (state: State) => state.ui.search.isSearchingRequestTypes;
export const getIsSearchingKb = (state: State) => state.ui.search.isSearchingKb;
